import React from 'react';
import Box from '@mui/material/Box';

import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OtpForm from '../components/registrationLayout/otpForm';
import Background from '../components/commonComponents/Background';

export default function OtpPage() {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" bgcolor="#1D2735" width="100%" height="100%">
      <Background
        src="https://taxofficestorage.blob.core.windows.net/media/loginBackground.svg"
        alt="Login background"
      />
      <Box
        width="100%"
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        zIndex={300}
      >
        <Paper
          sx={{
            zIndex: '1000',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '32px',
            gap: '32px',
            borderRadius: '15px',
            boxShadow: '0px 34px 114px rgba(0, 0, 0, 0.08)',
            width: { xs: '90%', sm: '50%', md: '480px' },
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row" width="100%">
            <Typography variant="h4" textAlign="center">
              {t('otpLogin')}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row" width="100%">
            <Typography variant="body1" textAlign="center">
              {t('otpLoginText')}
            </Typography>
          </Box>
          <Box width="100%" display="flex" flexDirection="column" justifyContent="center" padding={0} gap="32px">
            <OtpForm />
          </Box>
        </Paper>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="5px"
          paddingY={'30px'}
        ></Box>
      </Box>
    </Box>
  );
}
